import { render, staticRenderFns } from "./systemPay.vue?vue&type=template&id=6d8b9f20&scoped=true&"
import script from "./systemPay.vue?vue&type=script&lang=js&"
export * from "./systemPay.vue?vue&type=script&lang=js&"
import style0 from "./systemPay.vue?vue&type=style&index=0&id=6d8b9f20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b9f20",
  null
  
)

export default component.exports